import { render } from "./Multimidia.vue?vue&type=template&id=2d443467&scoped=true"
import script from "./Multimidia.vue?vue&type=script&lang=js"
export * from "./Multimidia.vue?vue&type=script&lang=js"

import "./Multimidia.vue?vue&type=style&index=0&id=2d443467&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d443467"]])

export default __exports__